// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-5d33f8fa] .el-table .warning-row{background:rgba(227,69,54,.429)}[data-v-5d33f8fa] .el-badge__content.is-fixed{top:10px!important;right:16px!important}", ""]);
// Exports
module.exports = exports;
